import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class FontsService {
	fonts: Array<Font>;
	path: string;

	constructor() {
		this.path = `${environment.dmAssetsDomain}/creator/fonts/`;
	}

	getFonts() {
		this.fonts = [
			{ key: 0, label: `Arial Black`, url: `${this.path}Arial_Black.ttf`, type: 'default' },
			{ key: 1, label: `Arial Narrow`, url: `${this.path}Arial_Narrow.ttf`, type: 'default' },
			{ key: 2, label: `Arial`, url: `${this.path}Arial.ttf`, type: 'default' },
			{ key: 3, label: `Courier New`, url: `${this.path}Courier_New.ttf`, type: 'default' },
			{ key: 4, label: `Georgia`, url: `${this.path}Georgia.ttf`, type: 'default' },
			{ key: 5, label: `Impact`, url: `${this.path}Impact.ttf`, type: 'default' },
			{ key: 6, label: `OpenSans`, url: `${this.path}OpenSans-Regular.ttf`, type: 'default' },
			{ key: 7, label: `Raleway`, url: `${this.path}Raleway-Regular.ttf`, type: 'default' },
			{ key: 8, label: `Roboto`, url: `${this.path}Roboto-Regular.ttf`, type: 'default' },
			{ key: 9, label: `Tahoma`, url: `${this.path}Tahoma.ttf`, type: 'default' },
			{ key: 10, label: `Times New Roman`, url: `${this.path}Times_New_Roman.ttf`, type: 'default' },
			{ key: 11, label: `Verdana`, url: `${this.path}Verdana.ttf`, type: 'default' },
			{ key: 12, label: `Custom Font`, url: `Custom Font`, type: 'custom' }
		];

		return this.fonts;
	}

	getFontsArray() {
		let fonts = [];
		this.getFonts().forEach((font) => {
			fonts.push(font.url);
		});
		return fonts;
	}
}

export interface Font {
	key: number;
	label: string;
	url: string;
	type?: string;
}
